import React from 'react';
import NativeSwiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import wrapStore from '@src/utils/wrap-store';
import BaseSwiperStore from './store';

/**
 * @param children
 * @param {BaseSwiperStore} store
 * @returns {JSX.Element}
 *
 * @example
 *
 * <BaseSwiper>
 *   <div>Slide 1</div>
 *   <div>Slide 2</div>
 *   <div>Slide 3</div>
 *   <div>Slide 4</div>
 *   <div>Slide 5</div>
 * </BaseSwiper>
 *
 * @constructor
 */
const BaseSwiper = ({ children, store }) => {
  store.use({ children });
  let swiperOptions = store.swiperOptions;
  if (store.isDisabled()) {
    swiperOptions = { noSwiping: true, loop: false };
  }
  return (
    <React.Fragment>
      {store.showSwiper && (
        <NativeSwiper {...swiperOptions} ref={store.swiperRef}>
          {children}
        </NativeSwiper>
      )}
    </React.Fragment>
  );
};

export default wrapStore(BaseSwiper, BaseSwiperStore);
